import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"
import { CircleCheckIcon, InfoIcon, TriangleAlertIcon, OctagonXIcon, Loader2Icon } from "lucide-react"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: (
          <CircleCheckIcon className="size-4" />
        ),
        info: (
          <InfoIcon className="size-4" />
        ),
        warning: (
          <TriangleAlertIcon className="size-4" />
        ),
        error: (
          <OctagonXIcon className="size-4" />
        ),
        loading: (
          <Loader2Icon className="size-4 animate-spin" />
        ),
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          // pointer-events-auto: Radix modals set pointer-events:none on <body>;
          // without the override the toast inherits that and the close button (X) is
          // dead while a dialog is open — but that's exactly when the error toasts (onError) appear.

          // The --toast-close-button-* variables move the X from top-left
          // (sonner default) to top-right.
          // [--toast-close-button-start:auto] [--toast-close-button-end:0] [--toast-close-button-transform:translate(35%,-35%)]
          toast:
            "cn-toast pointer-events-auto",
          // \n in Beschreibungen als Zeilenumbruch rendern (Message/Error code/Trace-ID).
          description: "whitespace-pre-line",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
